import { IP_ADDRESS_DATAS, LOADING_IP_ADDRESS_DATAS } from "../constants/userTracking";

const initialState = {
  ipAddressDatas: [],
  isLoadingIpAddressDatas: true,
  userTrackingDatas: [],
  isLoadingUserTrackingdatas: true,
};

export default function reducer(
  state = initialState,
  action = {
    type: "",
    ipAddressDatas: [],
    userTrackingDatas: [],
  }
) {
  const { type, ipAddressDatas, userTrackingDatas } = action;
  switch (type) {
    case IP_ADDRESS_DATAS:
      return {
        ...state,
        ipAddressDatas,
        isLoadingIpAddressDatas: false,
      };
    case LOADING_IP_ADDRESS_DATAS:
      return {
        ...state,
        isLoadingIpAddressDatas: true,
      };
    default:
      return state;
  }
}
